// extracted by mini-css-extract-plugin
export var loadingSpinner = "_5y-1";
export var standaloneTable = "_5y-0";